const isBlank = (value) => value === undefined || value === null || value === "";

// Blank values always sort last, like the server's sort, in either direction.
export const sortRows = (rows, getValue, direction) => {
  const factor = String(direction).toLowerCase() === "descending" ? -1 : 1;
  return [...rows].sort((a, b) => {
    const aValue = getValue(a);
    const bValue = getValue(b);
    if (isBlank(aValue) && isBlank(bValue)) return 0;
    if (isBlank(aValue)) return 1;
    if (isBlank(bValue)) return -1;
    const aNumber = Number(aValue);
    const bNumber = Number(bValue);
    if (!Number.isNaN(aNumber) && !Number.isNaN(bNumber)) return (aNumber - bNumber) * factor;
    return String(aValue).localeCompare(String(bValue)) * factor;
  });
};

// Canvas Map sort values, with the same Aristotle fallbacks the server's re-sort uses.
export const getCanvassSortValue = (row, sortBy) => {
  const p = row?.properties || {};
  if (sortBy === "house_number") return p.house_number || p.aristotle_house_num;
  if (sortBy === "residence_address_line") return p.residence_address_line || p.aristotle_address;
  if (sortBy === "residence_city") return p.residence_city || p.aristotle_city || p.mailing_city;
  return p[sortBy];
};

// Everything the list will ever show is already loaded, so a sort needs no new request.
export const canSortLocally = (allDataLoaded, rows) => !!allDataLoaded && Array.isArray(rows) && rows.length > 0;
